import getEnvVar from './getEnvVar';

const toBoolean = value => String(value).toLowerCase() === 'true';

const parseEnabledTenants = value => {
  if (!value) {
    return [];
  }

  return String(value)
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
};

const isFeatureEnabledForTenant = ({ enabledFlag, enabledTenantsFlag, tenantId }) => {
  const isEnabled = toBoolean(getEnvVar(enabledFlag));

  if (!isEnabled) {
    return false;
  }

  const enabledTenants = parseEnabledTenants(getEnvVar(enabledTenantsFlag));

  if (enabledTenants.length === 0) {
    return true;
  }

  const hasTenantId = tenantId !== null && tenantId !== undefined && `${tenantId}` !== '';

  return hasTenantId && enabledTenants.includes(String(tenantId));
};

export const isDashboardEnabledForTenant = tenantId =>
  isFeatureEnabledForTenant({
    enabledFlag: 'ADM_INCLUDE_DASHBOARD',
    enabledTenantsFlag: 'ADM_DASHBOARD_ENABLED_TENANTS',
    tenantId
  });

export const isSurveyAiPreviewEnabledForTenant = tenantId =>
  isFeatureEnabledForTenant({
    enabledFlag: 'ADM_SURVEY_AI_PREVIEW_ENABLED',
    enabledTenantsFlag: 'ADM_SURVEY_AI_PREVIEW_ENABLED_TENANTS',
    tenantId
  });

export const getDefaultLandingPathForTenant = tenantId =>
  isDashboardEnabledForTenant(tenantId) ? '/dashboard' : '/campaigns';
